interface SVGRProps {
    title?: string;
    titleId?: string;
}

const GoogleCalendarIcon: React.VFC<React.SVGProps<SVGSVGElement> & SVGRProps> = ({
    title,
    titleId,
    ...props
}) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M32.053 9.947H9.947v22.106h22.106V9.947z" fill="#fff" />
            <path d="M32.053 42L42 32.053h-9.947V42z" fill="#EA4335" />
            <path d="M42 9.947h-9.947v22.106H42V9.947z" fill="#FBBC04" />
            <path d="M32.053 32.053H9.947V42h22.106v-9.947z" fill="#34A853" />
            <path d="M0 32.053v6.631A3.315 3.315 0 003.316 42h6.631v-9.947H0z" fill="#188038" />
            <path d="M42 9.947V3.316A3.315 3.315 0 0038.684 0h-6.631v9.947H42z" fill="#1967D2" />
            <path
                d="M32.053 0H3.316A3.315 3.315 0 000 3.316v28.737h9.947V9.947h22.106V0z"
                fill="#4285F4"
            />
            <path
                d="M14.482 27.096c-.826-.559-1.398-1.374-1.71-2.451l1.917-.79c.174.663.478 1.177.912 1.541.43.365.956.545 1.57.545.627 0 1.165-.191 1.616-.572.45-.382.677-.868.677-1.457 0-.602-.238-1.094-.713-1.475-.476-.381-1.072-.572-1.785-.572h-1.108v-1.898h.994c.614 0 1.13-.166 1.55-.498.42-.331.63-.785.63-1.362 0-.514-.187-.923-.563-1.23-.376-.306-.851-.461-1.429-.461-.563 0-1.01.15-1.342.45-.332.302-.581.684-.725 1.108l-1.898-.79c.252-.713.713-1.343 1.39-1.887.677-.544 1.542-.818 2.592-.818.776 0 1.476.15 2.094.45a3.583 3.583 0 011.457 1.25c.35.533.525 1.13.525 1.793 0 .677-.163 1.249-.49 1.718a3.37 3.37 0 01-1.201 1.08v.114a3.65 3.65 0 011.541 1.202c.401.539.603 1.183.603 1.934 0 .752-.19 1.423-.572 2.012a3.962 3.962 0 01-1.578 1.39c-.671.337-1.426.508-2.263.508a4.685 4.685 0 01-2.691-.834zm11.779-9.517l-2.105 1.523-1.053-1.597 3.777-2.725h1.448v12.852H26.26V17.579z"
                fill="#4285F4"
            />
        </svg>
    );
};

export default GoogleCalendarIcon;
